export class ConstantService {

  constructor() { }
  static getDynamicBaseUrl() {
    if (typeof window !== 'undefined') {
      const origin = window.location.origin;
      if (
        origin === 'https://dotcom-staging.rolzo.com' ||
        origin === 'http://localhost:8080'
        ) {
        return 'https://staging.rolzo.com/api/api/v1/';
      } else {
        return 'https://business.rolzo.com/api/api/v1/';
      }
    }

    // Fallback for SSR
    return process.env.NEXT_PUBLIC_API_URL || '';
  }
  /**
   * all the apiRoutes are declared here.
   */
  static apiRoutes = {
    home: `${process.env.NEXT_PUBLIC_API_URL}fleetHome/`,
    fleet: `${process.env.NEXT_PUBLIC_API_URL}fleetList/`,
    joinRolzo: `${process.env.NEXT_PUBLIC_API_URL}joinRolzo/`,
    businessAccount: `${process.env.NEXT_PUBLIC_API_URL}/businessAccount/`,
    eventsAccount: `${process.env.NEXT_PUBLIC_API_URL}/eventsAccount/`,
    priveAccount: `${process.env.NEXT_PUBLIC_API_URL}/priveAccount/`,
    rolzoApiAccount: `${process.env.NEXT_PUBLIC_API_URL}/rolzoApiAccount/`,
    // businessAccount: `${this.getDynamicBaseUrl()}businessAccount/`,
    // eventsAccount: `${this.getDynamicBaseUrl()}eventsAccount/`,
    // priveAccount: `${this.getDynamicBaseUrl()}priveAccount/`,
    // rolzoApiAccount: `${this.getDynamicBaseUrl()}rolzoApiAccount/`,
    ipLocation: `${process.env.NEXT_PUBLIC_API_URL}/getIpLocation/`,
    fleetNew: 'https://fleet.rolzo.com/fleet/fleetList/',
    // fleetNew: 'http://localhost:3005/fleet/fleetList/',
    // fleetNew: 'http://localhost:4000/fleet/fleetList/',
    homeNew: 'https://fleet.rolzo.com/fleet/fleetHome/'
  };

  /**
   * all the api methods are declared here.
   */
  static apiMethod = {
    get: 'get',
    post: 'post',
    put: 'put',
    delete: 'delete'
  };

  /**
   * london City place ID to search location for fleet by default
   */
  static cityIdLondon = "ChIJdd4hrwug2EcRmSrV3Vo6llI";

  /**
   * all currencies with sign, name and value for backend
   */
  static currency = [
    {
      name: 'GBP',
      sign: '£',
      value: 'currency_gbp'
    },
    {
      name: 'EUR',
      sign: '€',
      value: 'currency_eur'
    },
    {
      name: 'USD',
      sign: '$',
      value: 'currency_usd'
    },
    {
      name: 'AED',
      sign: 'د.إ',
      value: 'currency_aed'
    }
  ]
}

  